import ReviewContext from "context/ReviewContext";
import { useLocalObservable } from "mobx-react-lite";
import { ReactNode } from "react";
import { ReviewState } from "state/ReviewState";

interface IProps {
	children?: ReactNode;
}

export const ReviewProvider = ({ children }: IProps) => {
	const store = useLocalObservable(() => new ReviewState());
	return <ReviewContext.Provider value={store}>{children}</ReviewContext.Provider>;
};
